module.exports = __webpack_public_path__ + "img/cc8cb22.png";